export enum PlatformAudience {
  ALL = "ALL",
  SELLERS = "SELLERS",
  BUYERS = "BUYERS",
  USERS = "USERS",
}
